module.exports = __webpack_public_path__ + "img/forest_natural_ba_list.1439a196.jpg";